import Team from "../components/Team/Team";
import Features from "../components/Features/Features";
import HeroCarousel from "../components/HeroCarousel/HeroCarousel";
import Description from "../components/Description/Description";
import Reasons from "../components/Reasons/Reasons";
import WhatsApp from "../assets/icons/whatsapp.png";
import { useCallback, useContext, useEffect, useState } from "react";
import { ScrollContext } from "../contexts/ScrollContext";
import { ArrowUpCircleIcon } from "@heroicons/react/24/solid";
import Tarif from "../components/Tarif/Tarif";

export default function Home() {
  const [isScrollVisible, setIsScrollVisible] = useState(false);
  const { scrollRef } = useContext(ScrollContext);
  const listenToScroll = useCallback(
    (a) => {
      const { scrollTop } = scrollRef?.current;
      let H = 200;
      if (scrollTop > H) {
        setIsScrollVisible(true);
      } else {
        setIsScrollVisible(false);
      }
    },
    [scrollRef]
  );
  useEffect(() => {
    scrollRef?.current?.addEventListener("scroll", listenToScroll);
    return () =>
      // eslint-disable-next-line react-hooks/exhaustive-deps
      scrollRef?.current?.removeEventListener("scroll", listenToScroll);
  }, [listenToScroll, scrollRef]);
  return (
    <>
      {isScrollVisible && (
        <ArrowUpCircleIcon
          className={`fixed h-10 bottom-10 left-10 z-50  text-[#674DA2] cursor-pointer animate-[bounce_1s_ease-in-out_2.5] `}
          onClick={() => {
            scrollRef?.current?.scrollTo({
              top: 0,
              behavior: "smooth",
              block: "start",
            });
          }}
        />
      )}
      <section>
        <HeroCarousel />
      </section>
      <section>
        <Description />
      </section>
      <section className="pt-24">
        <Features />
      </section>
      <section>
        <Reasons />
      </section>
      <section>
        <Team />
      </section>
      <section>
        <Tarif />
      </section>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/+77776655965" // Replace with your WhatsApp number
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 z-50 hover:scale-110 transition-transform duration-300"
      >
        <img
          src={WhatsApp} // Make sure this image is in public/ directory
          alt="WhatsApp Chat"
          className="md:w-16 md:h-16 w-12 h-12"
        />
      </a>
    </>
  );
}
